import { render, staticRenderFns } from "./ShowSvgSectionComponent.vue?vue&type=template&id=a22f3054"
import script from "./ShowSvgSectionComponent.vue?vue&type=script&lang=js"
export * from "./ShowSvgSectionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports